import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { notifyParentOfUrlChange } from "../utils/iframe_messaging"

export default class extends Controller {
  connect() {
   this.element.querySelector('#save-setting').addEventListener('click', this.save.bind(this))
  }

  save() {
    const data = {
      save_setting: true
    }

    const view = this.element.querySelector('input[name="view"]:checked')
    if (view) data.view = view.value

    const reciter = this.element.querySelector('select[name="reciter"]')
    if (reciter) data.reciter = reciter.value

    const mushaf = this.element.querySelector('select[name="mushaf"]')
    if (mushaf) data.mushaf = mushaf.value

    const inline = this.element.querySelector('input[name="inline_word_translation"]')
    const tooltip = this.element.querySelector('input[name="tooltip_word_translation"]')
    const transliteration = this.element.querySelector('input[name="show_transliteration"]')
    if (inline?.checked) data.inline_word_translation = true
    if (tooltip?.checked) data.tooltip_word_translation=true
    if (transliteration?.checked) data.show_transliteration = true

    const lang = this.element.querySelector('select[name="word_translation_language"]')
    if (lang) data.word_translation_language = lang.value

    const queryString = new URLSearchParams(data).toString()

    // Ensure we use the correct protocol for the current environment
    const protocol = window.location.protocol
    const host = window.location.host
    const pathname = window.location.pathname
    const baseUrl = `${protocol}//${host}${pathname}`
    const finalUrl = `${baseUrl}?${queryString}`
    
    notifyParentOfUrlChange(finalUrl);
    Turbo.visit(finalUrl)
  }
}
